import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/client";
import { Button, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import swal from "sweetalert";
import { Search } from "@mui/icons-material";

const AddFeatured = () => {
  const [isloaded, setIsLoaded] = useState(false);
  const [del, setDel] = useState(false);
  const [getList, setGetList] = useState([]);
  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
 
  const [pageSize, setPageSize] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    handleSearch();
  }, [currentPage, del]);

  const handleKey = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  

  const handleSearch = async () => {
    
      const { data } = await apiClient.get("/package/", {
       
        pageNumber: currentPage,
      });
   
      setGetList(data);
      setData(data?.products);
      setPageSize(data?.pageCount);
    
  };

  const handleaddtoorderagain = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You want to Add ",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (success) => {
      if (success) {
        const a = sessionStorage.getItem("token");
        const config = {
          headers: {
            "x-auth-token": a,
          },
        };
        setIsLoaded(true);
        const { data } = await apiClient.post("/featured/create-featured-package", {
          id,
        }, config);

        setIsLoaded(false);
        navigate("/package/featured");
      }
    });
  };

  return (
    <div id="layoutSidenav_content">
      <main>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5 col-md-9 col-lg-6">
              <h2 className="mt-30 page-title">Packages</h2>
            </div>
            <div className="col-lg-5 col-md-3 col-lg-6 back-btn">
              <Button variant="contained" onClick={(e) => navigate("/")}>
                <i className="fas fa-arrow-left" /> Back
              </Button>
            </div>
          </div>
          <ol className="breadcrumb mb-30">
            <li className="breadcrumb-item">
              <a href="index.html">Dashboard</a>
            </li>
            <li className="breadcrumb-item active">Packages</li>
          </ol>
          {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <input
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => handleKey(e)}
              />
              <Search
                style={{ color: "gray", fontSize: 26, marginRight: "10px" }}
                onClick={handleSearch}
              />
            </div>
          </div> */}

          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mt-30 mb-30">
              {/* <div className="card-title-2">
                <h4>Search Service to add</h4>
              </div> */}
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>No.</th>
                        <th style={{ width: 100 }}>Image</th>
                        <th>Name</th>
                     

                        

                        <th>Add To Featured</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isloaded !== true && data?.length > 0
                        ? data?.map((row, index) => {

                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="cate-img-5">
                                    <img src={row?.image ? row?.image[0] : ""}
                                      alt="service-name"/>
                                  </div>
                                </td>
                                <td>{row?.name}</td>

                              

                                <td>
                                  <Typography
                                    className="delete-btn"
                                    onClick={(e) =>
                                      handleaddtoorderagain(row._id)
                                    }
                                  >
                                    <i className="fas fa-edit" />
                                  </Typography>
                                </td>

                                <td></td>
                              </tr>
                            );
                          })
                        : "Loading..."}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            count={[pageSize]}
            page={currentPage}
            siblingCount={1}
            color="primary"
            onChange={(e, value) => setCurrentPage(value)}
          />
        </div>
      </main>
    </div>
  );
};

export default AddFeatured;
